import { Opcode_delete, SPIN_DIALOG_HIDE, SPIN_DIALOG_SHOW } from "../const/infoConst";
import { bigEndianToLittleEndian, getOctets2Msg, sumHexBytes, transIntToHex2Str, transIntToHex4Str, transIntToHex3Str } from "./dataUtils";
import { decimalToVersionString2 } from "./deviceUtils";
import { saveGroupInfor, saveDeviceInfor } from "./homeUtils";
import { meshLog, SPGet, SPSet } from "./spUtils";
import axios from "axios";
import PubSub from 'pubsub-js'
//---------------------------------------------------------------Group--------------------------------------------------------------
//group--on off
export const sendOpcode_group_onoff = async (key) => {
    meshLog('key', key);
    const wangguan = JSON.parse(SPGet("wangguan"))
    const groupList = JSON.parse(SPGet("groupList"))
    const groupInfoLast = JSON.parse(SPGet("groupInfo"))
    let groupInfo = groupList.find(item => item.groupID == groupInfoLast.groupID)
    const wangguanmac = bigEndianToLittleEndian(wangguan.macAddress)
    const groupID = groupInfo.groupID
    let data1 = '252517'
    let data
    let data2
    let data3
    if (key == 'isOn') {
        let date4 = groupInfo.isOnOff == true ? '00' : '01'
        let date5 = !groupInfo.isOnOff
        meshLog('isOndate5', date5);
        data2 = '00006100000000000003' + getOctets2Msg(transIntToHex4Str(groupID)) + '0000000000640000' + '0110' + date4 + '0A' //64是100的亮度值
        data3 = sumHexBytes(data2) + '5252'
        data = '0,' + data1 + data2 + data3 + ',';
        //修改localStorage上数据
        groupInfo.isOnOff = date5
        meshLog('groupInfo', groupInfo);
        const groupListAll = saveGroupInfor(groupInfo)
        meshLog('groupListAll', groupListAll);
    } else if (key == 'motionSensorEnabled') {
        let motionModel = groupInfo.motionModel
        let daylightModel = groupInfo.daylightModel
        meshLog('motionModelmotionModel', motionModel);
        let date4 = motionModel.isEnabled == true ? '00' : '01'
        let date5 = !motionModel.isEnabled
        let data6 = daylightModel.isEnabled == true ? '00' : '01'
        meshLog('date5', date5);
        data2 = '00006100000000000003' + getOctets2Msg(transIntToHex4Str(groupID)) + '0000000000640000' + '3110' + date4 + 'FF' //同时需要上传两个状态人感，光感
        data3 = sumHexBytes(data2) + '5252'
        data = '0,' + data1 + data2 + data3 + ',';
        //修改localStorage上数据
        motionModel.isEnabled = date5
        meshLog('groupInfo', groupInfo);
        const groupListAll = saveGroupInfor(groupInfo)
        meshLog('groupListAll', groupListAll);
    } else if (key == 'daylightSensor') {
        let motionModel = groupInfo.motionModel
        let daylightModel = groupInfo.daylightModel
        meshLog('daylightModel', daylightModel);
        let date4 = daylightModel.isEnabled == true ? '00' : '01'
        let date5 = !daylightModel.isEnabled
        let data6 = motionModel.isEnabled == true ? '00' : '01'
        meshLog('date5', date5);
        data2 = '00006100000000000003' + getOctets2Msg(transIntToHex4Str(groupID)) + '0000000000640000' + '3110' + 'FF' + date4   //同时需要上传两个状态人感，光感
        data3 = sumHexBytes(data2) + '5252'
        data = '0,' + data1 + data2 + data3 + ',';
        //修改localStorage上数据
        daylightModel.isEnabled = date5
        meshLog('groupInfo', groupInfo);
        const groupListAll = saveGroupInfor(groupInfo)
        meshLog('groupListAll', groupListAll);
    } else if (key == 'vacantSwitch') {
        data2 = '00006100000000000003' + getOctets2Msg(transIntToHex4Str(groupID)) + '0000000000640000' + '3110' + "02" + 'FF' //同时需要上传两个状态人感，光感
        data3 = sumHexBytes(data2) + '5252'
        data = '0,' + data1 + data2 + data3 + ',';
        //修改localStorage上
    } else if (key == 'vacantSwitch2') {
        data2 = '00006100000000000003' + getOctets2Msg(transIntToHex4Str(groupID)) + '0000000000640000' + '3110' + "00" + 'FF' //同时需要上传两个状态人感，光感
        data3 = sumHexBytes(data2) + '5252'
        data = '0,' + data1 + data2 + data3 + ',';
        //修改localStorage上
    } else if (key == 'isDaylightHarvesting') {
        let motionModel = groupInfo.motionModel
        let daylightModel = groupInfo.daylightModel
        let date4 = daylightModel.isDaylightHarvesting === true ? '00' : '01'
        let date5 = !daylightModel.isDaylightHarvesting
        data1 = '252516'
        meshLog('date5', date5);
        data2 = '00006100000000000003' + getOctets2Msg(transIntToHex4Str(groupID)) + '0000000000640000' + 'A110' + date4  //同时需要上传两个状态人感，光感
        data3 = sumHexBytes(data2) + '5252'
        data = '0,' + data1 + data2 + data3 + ',';
        //修改localStorage上数据
        daylightModel.isDaylightHarvesting = date5
        meshLog('groupInfo', groupInfo);
        const groupListAll = saveGroupInfor(groupInfo)
        meshLog('groupListAll', groupListAll);
    } else if (key == 'isPhotoCell') {
        let motionModel = groupInfo.motionModel
        let daylightModel = groupInfo.daylightModel
        let date4 = daylightModel.isPhotoCell === true ? '00' : '01'
        let date5 = !daylightModel.isPhotoCell
        data1 = '252516'
        meshLog('date5', date5);
        data2 = '00006100000000000003' + getOctets2Msg(transIntToHex4Str(groupID)) + '0000000000640000' + '8410' + date4  //同时需要上传两个状态人感，光感
        data3 = sumHexBytes(data2) + '5252'
        data = '0,' + data1 + data2 + data3 + ',';
        //修改localStorage上数据
        daylightModel.isPhotoCell = date5
        meshLog('groupInfo', groupInfo);
        const groupListAll = saveGroupInfor(groupInfo)
        meshLog('groupListAll', groupListAll);
    }//新增的
    else if (key == 'DaylightHarvesting') {
        data1 = '252515'
        data2 = '00006100000000000003' + getOctets2Msg(transIntToHex4Str(groupID)) + '0000000000640000' + 'A410'   //不需要传值
        data3 = sumHexBytes(data2) + '5252'
        data = '0,' + data1 + data2 + data3 + ',';
        //修改localStorage上数据

    }
    else if (key == 'EmergencyTest') {
        let date4 = '01'
        data2 = '00006100000000000003' + getOctets2Msg(transIntToHex4Str(groupID)) + '0000000000640000' + 'D110' + date4 + '0A' //64是100的亮度值
        data3 = sumHexBytes(data2) + '5252'
        data = '0,' + data1 + data2 + data3 + ',';
        //修改localStorage上数据
    }
    PubSub.publish('showUpdate', data)//控制mqtt发信息
}

//group--调光
export const sendOpcode_group_light = async (key, value) => {
    meshLog('key', key, value);
    const wangguan = JSON.parse(SPGet("wangguan"))
    const groupList = JSON.parse(SPGet("groupList"))
    const groupInfoLast = JSON.parse(SPGet("groupInfo"))
    let groupInfo = groupList.find(item => item.groupID == groupInfoLast.groupID)
    const wangguanmac = bigEndianToLittleEndian(wangguan.macAddress)
    const groupID = groupInfo.groupID
    let data1
    let data
    let data2
    let data3
    if (key == 'dimLevel') {
        meshLog('value1', value);
        data1 = '252517'
        data2 = '00006100000000000003' + getOctets2Msg(transIntToHex4Str(groupID)) + '0000000000640000' + '1110' + (transIntToHex2Str(value)) + '0A' //64是100的亮度值
        data3 = sumHexBytes(data2) + '5252'
        data = '0,' + data1 + data2 + data3 + ',';
        //修改localStorage上数据
        groupInfo.dimLevel = value
        //meshLog('groupInfo', groupInfo);
        const groupListAll = saveGroupInfor(groupInfo)
        meshLog('groupListAll', groupListAll);
    } else if (key == 'cctLevel') {
        meshLog('value', value);
        const cctModeArray = groupInfo.cctModeArray
        const cctLevelValue = Math.round(((cctModeArray[cctModeArray.length - 1] - cctModeArray[0]) * (value) / 400) + cctModeArray[0])
        data1 = '252518'
        data2 = '00006100000000000003' + getOctets2Msg(transIntToHex4Str(groupID)) + '0000000000640000' + '2110' + getOctets2Msg(transIntToHex4Str(value)) + '0A' //色温
        data3 = sumHexBytes(data2) + '5252'
        data = '0,' + data1 + data2 + data3 + ',';
        //修改localStorage上数据
        groupInfo.cctLevel = value
        //meshLog('groupInfo', groupInfo);
        const groupListAll = saveGroupInfor(groupInfo)
        meshLog('groupListAll', groupListAll);
    } else if (key == 'cctLevelValue') {
        meshLog('value', value);
        const cctModeArray = groupInfo.cctModeArray
        const cctLevel = Math.round(((value - cctModeArray[0]) / (cctModeArray[cctModeArray.length - 1] - cctModeArray[0]) * 400))
        data1 = '252518'
        data2 = '00006100000000000003' + getOctets2Msg(transIntToHex4Str(groupID)) + '0000000000640000' + '2110' + getOctets2Msg(transIntToHex4Str(cctLevel)) + '0A' //色温
        data3 = sumHexBytes(data2) + '5252'
        data = '0,' + data1 + data2 + data3 + ',';
        //修改localStorage上数据
        groupInfo.cctLevel = cctLevel
        //meshLog('groupInfo', groupInfo);
        const groupListAll = saveGroupInfor(groupInfo)
        meshLog('groupListAll', groupListAll);
    } else if (key == 'detectionArea') {
        let motionModel = groupInfo.motionModel
        let detectionSensitivity = 0
        if (value == 'Low') {
            detectionSensitivity = 0
        } else if (value == 'Medium') {
            detectionSensitivity = 1
        } else {
            detectionSensitivity = 2
        }
        data1 = '252516'
        data2 = '00006100000000000003' + getOctets2Msg(transIntToHex4Str(groupID)) + '0000000000640000' + '4110' + (transIntToHex2Str(detectionSensitivity))  //色温
        data3 = sumHexBytes(data2) + '5252'
        data = '0,' + data1 + data2 + data3 + ',';
        //修改localStorage上数据
        motionModel.detectionSensitivity = detectionSensitivity
        //meshLog('groupInfo', groupInfo);
        const groupListAll = saveGroupInfor(groupInfo)
        meshLog('groupListAll', groupListAll);
    } else if (key == 'maxDim') {
        let motionModel = groupInfo.motionModel
        let maxLight = parseInt(value.replace("%", ""))
        //meshLog('maxLight', maxLight);
        data1 = '252516'
        data2 = '00006100000000000003' + getOctets2Msg(transIntToHex4Str(groupID)) + '0000000000640000' + '5110' + (transIntToHex2Str(maxLight))  //色温
        data3 = sumHexBytes(data2) + '5252'
        data = '0,' + data1 + data2 + data3 + ',';
        //修改localStorage上数据
        motionModel.maxLight = maxLight
        //meshLog('groupInfo', groupInfo);
        const groupListAll = saveGroupInfor(groupInfo)
        meshLog('groupListAll', groupListAll);
    } else if (key == 'holdTime') {
        let motionModel = groupInfo.motionModel
        let holdTime = parseInt(value.replace("s", ""))
        meshLog('holdTime', holdTime);
        data1 = '252517'
        data2 = '00006100000000000003' + getOctets2Msg(transIntToHex4Str(groupID)) + '0000000000640000' + '6110' + getOctets2Msg(transIntToHex4Str(holdTime))  //色温
        data3 = sumHexBytes(data2) + '5252'
        data = '0,' + data1 + data2 + data3 + ',';
        //修改localStorage上数据
        motionModel.holdTime = holdTime
        //meshLog('groupInfo', groupInfo);
        const groupListAll = saveGroupInfor(groupInfo)
        meshLog('groupListAll', groupListAll);
    } else if (key == 'standbyDim') {
        let motionModel = groupInfo.motionModel
        let standbyDim = parseInt(value.replace("%", ""))
        //meshLog('maxLight', maxLight);
        data1 = '252516'
        data2 = '00006100000000000003' + getOctets2Msg(transIntToHex4Str(groupID)) + '0000000000640000' + '7110' + (transIntToHex2Str(standbyDim))  //色温
        data3 = sumHexBytes(data2) + '5252'
        data = '0,' + data1 + data2 + data3 + ',';
        //修改localStorage上数据
        motionModel.standbyDim = standbyDim
        //meshLog('groupInfo', groupInfo);
        const groupListAll = saveGroupInfor(groupInfo)
        meshLog('groupListAll', groupListAll);
    } else if (key == 'standbyPeriod') {
        let motionModel = groupInfo.motionModel
        let standbyPeriod = parseInt(value.replace("s", ""))
        meshLog('standbyPeriod', standbyPeriod);
        data1 = '252517'
        data2 = '00006100000000000003' + getOctets2Msg(transIntToHex4Str(groupID)) + '0000000000640000' + '8110' + getOctets2Msg(transIntToHex4Str(standbyPeriod))  //色温
        data3 = sumHexBytes(data2) + '5252'
        data = '0,' + data1 + data2 + data3 + ',';
        //修改localStorage上数据
        motionModel.standbyPeriod = standbyPeriod
        //meshLog('groupInfo', groupInfo);
        const groupListAll = saveGroupInfor(groupInfo)
        meshLog('groupListAll', groupListAll);
    } else if (key == 'daylightThreshold') {
        let motionModel = groupInfo.motionModel
        let daylightThreshold = parseInt(value.substring(0, 3))
        meshLog('daylightThreshold', daylightThreshold);
        data1 = '252517'
        data2 = '00006100000000000003' + getOctets2Msg(transIntToHex4Str(groupID)) + '0000000000640000' + '9110' + getOctets2Msg(transIntToHex4Str(daylightThreshold))  //色温
        data3 = sumHexBytes(data2) + '5252'
        data = '0,' + data1 + data2 + data3 + ',';
        //修改localStorage上数据
        motionModel.daylightThreshold = daylightThreshold
        //meshLog('groupInfo', groupInfo);
        const groupListAll = saveGroupInfor(groupInfo)
        meshLog('groupListAll', groupListAll);
    } else if (key == 'isOn') {
        data1 = '252517'
        let date4 = value == true ? '01' : '00'
        let date5 = value
        meshLog('isOndate5', date5);
        data2 = '00006100000000000003' + getOctets2Msg(transIntToHex4Str(groupID)) + '0000000000640000' + '0110' + date4 + '0A' //64是100的亮度值
        data3 = sumHexBytes(data2) + '5252'
        data = '0,' + data1 + data2 + data3 + ',';
        //修改localStorage上数据
        groupInfo.isOnOff = date5
        meshLog('groupInfo', groupInfo);
        const groupListAll = saveGroupInfor(groupInfo)
        meshLog('groupListAll', groupListAll);
    } else if (key == 'monthlyTest') {
        data1 = '252517'
        let date4 = value == true ? '01' : '00'
        data2 = '00006100000000000003' + getOctets2Msg(transIntToHex4Str(groupID)) + '0000000000640000' + '4222' + '73' + date4 //64是100的亮度值
        data3 = sumHexBytes(data2) + '5252'
        data = '0,' + data1 + data2 + data3 + ',';
        //修改localStorage上数据
    } else if (key == 'annualTest') {
        data1 = '252517'
        let date4 = value == true ? '01' : '00'
        data2 = '00006100000000000003' + getOctets2Msg(transIntToHex4Str(groupID)) + '0000000000640000' + '4222' + '74' + date4 //64是100的亮度值
        data3 = sumHexBytes(data2) + '5252'
        data = '0,' + data1 + data2 + data3 + ',';
        //修改localStorage上数据
    } else if (key == 'EmergencyTest') {
        data1 = '252516'
        let date4 = value == true ? '01' : '00'
        data2 = '00006100000000000003' + getOctets2Msg(transIntToHex4Str(groupID)) + '0000000000640000' + 'D110' + date4 //64是100的亮度值
        data3 = sumHexBytes(data2) + '5252'
        data = '0,' + data1 + data2 + data3 + ',';
        //修改localStorage上数据
    } else if (key == 'isEnableVGroup') {
        data1 = '252517'
        let date4 = value == true ? '01' : '00'
        let date5 = value
        meshLog('isEnableVGroup', date5);
        data2 = '00006100000000000003' + getOctets2Msg(transIntToHex4Str(groupID)) + '0000000000640000' + 'C110' + date4 + '0A' //64是100的亮度值
        data3 = sumHexBytes(data2) + '5252'
        data = '0,' + data1 + data2 + data3 + ',';
        //修改localStorage上数据
        groupInfo.isEnableVGroup = date5
        meshLog('groupInfo', groupInfo);
        const groupListAll = saveGroupInfor(groupInfo)
        meshLog('groupListAll', groupListAll);
    }
    PubSub.publish('showUpdate', data)//控制mqtt发信息0210
}
//---------------------------------------------------------------Device--------------------------------------------------------------
//identify
export const sendOpcode_identify = async (device) => {
    console.log('devicedevicedevice', device);
    let mac = bigEndianToLittleEndian(device.macAddress);
    const wangguan = JSON.parse(SPGet("wangguan"))
    const wangguanmac = bigEndianToLittleEndian(wangguan.macAddress)
    meshLog('mac', mac);
    meshLog('wangguanmac', wangguanmac);
    let data1 = '252517'
    let data2 = '00006100000000000001' + mac + '00640000' + '1B00' + '640A' //64是100的亮度值
    let data3 = sumHexBytes(data2) + '5252'
    let value = data1 + data2 + data3
    var data = '0,' + value + ',';

    // //修改数据库中的数据
    // //let groupSetx = saveGroupInfor(item, groupStatusX)
    PubSub.publish('showUpdate', data)//控制mqtt发信息

    // meshLog('data3', data3);  104E2000015A
}

//device--ota
export const sendOpcode_device_ota = () => {
    PubSub.publish(SPIN_DIALOG_SHOW, "");//加载框

    const element = JSON.parse(SPGet("controlDevice"))
    meshLog('element', element);
    let mac = bigEndianToLittleEndian(element.macAddress);
    let OTApid = getOctets2Msg(transIntToHex2Str(element.pid));
    meshLog('OTApid', OTApid);
    //查版本
    const wangguan = JSON.parse(SPGet("wangguan"))
    const wangguanmac = bigEndianToLittleEndian(wangguan.macAddress)
    const OTAValue = -1000
    SPSet("OTAValue", JSON.stringify(OTAValue))
    SPSet("OTAMAC", JSON.stringify(mac))
    SPSet("OTApid", JSON.stringify(OTApid))
    meshLog('OTApid', OTApid);
    //新添加ota逻辑
    const otaurl = 'https://iot.hsesmartinc.com/light/version.json'
    axios.get(otaurl)
        .then(async (value) => {
            meshLog('value', value.data);
            const alldate = value.data.alldate
            for (let i = 0; i < alldate.length; i++) {
                if (alldate[i].pid == OTApid) {
                    const firmware_version = alldate[i].version
                    console.log('firmware_version:', firmware_version);
                    SPSet("firmware_version", JSON.stringify(firmware_version))
                }

            }
            console.log('firmware_version:', value.data);


        })
        .catch((resaon) => {
            meshLog(resaon);
        })
    //新添加ota逻辑

    meshLog('mac', mac);
    meshLog('wangguanmac', wangguanmac);
    let data1 = '252515'
    let data2 = '0000610000000000000F' + 'FFFFFFFFFFFF' + '00640000' + '0E00' //64是100的亮度值
    let data3 = sumHexBytes(data2) + '5252'
    let value = data1 + data2 + data3
    var data = '0,' + value + ',';
    //发送数据
    PubSub.publish('showUpdate', data)//控制mqtt发信息
    meshLog('ota第一步，获取灯的版本的命令', data);
    PubSub.unsubscribe("OTAfrist")
    PubSub.subscribe('OTAfrist', (msg, datas) => {
        meshLog('msgdatas', datas);
        const vidNew = decimalToVersionString2(parseInt(getOctets2Msg(datas.slice(52, 56)), 16))
        meshLog('vidNew', vidNew);
        const firmware_version = JSON.parse(SPGet("firmware_version"))
        meshLog('firmware_version', firmware_version);
        const versionNew = firmware_version.slice(firmware_version.length - 6, firmware_version.length)
        meshLog('versionNew', versionNew.slice(0, 2));
        meshLog('versionNew1', vidNew[0]);
        if (vidNew[0] == versionNew.slice(0, 2) && vidNew[1] == versionNew.slice(2, 4) && vidNew[2] == versionNew.slice(4, 6)) {
            alert("No need for OTA")
        } else {
            var data = '2,' + firmware_version + ',' + mac + ',';
            PubSub.publish('showUpdate', data)//控制mqtt发信息
            meshLog('需要ota',);
            // alert("请求已经发出")
        }
    })

    PubSub.unsubscribe("OTASecond")
    PubSub.subscribe('OTASecond', (msg, datas) => {
        meshLog('msgdatas', datas);
        const OTAPanduan = datas.slice(16, 18)
        meshLog('OTAPanduan', OTAPanduan);
        PubSub.publish(SPIN_DIALOG_HIDE, "");
        if (OTAPanduan == '00') {
            alert("OTA fail")
        } else {
            alert("OTA success")
            const firmware_version = JSON.parse(SPGet("firmware_version"))
            const newv = parseInt(firmware_version.substring(firmware_version.length - 6))
            const device_detail = JSON.parse(SPGet("controlDevice"))
            const newv2 = Math.floor(newv / 10000) * 2048 + newv % 10000 / 100 * 64 + newv % 100;
            device_detail.vid = newv2
            meshLog('newv', newv / 10000 * 2048);
            meshLog('groupInfo', device_detail);
            meshLog('newv2newv2', newv2);
            const nodes = saveDeviceInfor(device_detail)
            meshLog('nodes', nodes);
            PubSub.publish('otaupdate', newv2);


        }
    })
}

//device--on off
export const sendOpcode_device_onOff = (date5) => {
    const wangguan = JSON.parse(SPGet("wangguan"))
    const device_detail = JSON.parse(SPGet("controlDevice"))
    const wangguanmac = bigEndianToLittleEndian(wangguan.macAddress)
    const macAddress = device_detail.macAddress
    let data1 = '252516'
    let data
    let data2
    let data3
    let date4 = date5 === true ? '01' : '00'
    meshLog('date4', date4);
    meshLog('date5', date5);
    data2 = '00006100000000000001' + bigEndianToLittleEndian(macAddress) + '00640000' + '0110' + date4  //64是100的亮度值
    data3 = sumHexBytes(data2) + '5252'
    meshLog('sumHexBytes(data2)', sumHexBytes(data2));
    data = '0,' + data1 + data2 + data3 + ',';

    //修改localStorage上数据,暂时不更新数据库
    // device_detail[0].isOnOff = date5
    // meshLog('groupInfo', device_detail);
    // const nodes = saveDeviceInfor(device_detail)
    // meshLog('nodes', nodes);

    PubSub.publish('showUpdate', data)//控制mqtt发信息
}

//device--调光
export const sendOpcode_device_light = (key, value) => {
    meshLog('key', key, value);
    const wangguan = JSON.parse(SPGet("wangguan"))
    const device_detail = JSON.parse(SPGet("controlDevice"))
    const wangguanmac = bigEndianToLittleEndian(wangguan.macAddress)
    const macAddress = device_detail.macAddress
    let data1 = '252516'
    let data
    let data2
    let data3
    if (key == 'dimLevel') {
        meshLog('value', value);
        data1 = '252517'
        data2 = '00006100000000000001' + bigEndianToLittleEndian(macAddress) + '00640000' + '1110' + (transIntToHex2Str(value)) + '0A' //64是100的亮度值
        data3 = sumHexBytes(data2) + '5252'
        data = '0,' + data1 + data2 + data3 + ',';
        //修改localStorage上数据
    }
    PubSub.publish('showUpdate', data)//控制mqtt发信息0210
}


//获取组的状态的状态
export const sendOpcode_group_state = () => {
    const data = '5,00000'
    PubSub.publish('showUpdate', data)//控制mqtt发信息0210
}

//获取组的单灯的状态
export const sendOpcode_devices_state = () => {
    const data = '4,1'
    PubSub.publish('showUpdate', data)//控制mqtt发信息0210
}


//获取所有的设备的最新状态
export const sendOpcode_alldevices_state = () => {
    const data = '8,1'
    PubSub.publish('showUpdate', data)//控制mqtt发信息0210
}


//日程管理
export const sendOpcode_schedule_state = (sche, opcode_type) => {
    PubSub.publish(SPIN_DIALOG_SHOW, '');//加载框
    meshLog('wjk 日程管理 指令', sche);
    let time = sche.time;
    let sceneID = sche.sceneID;
    let sceneMode = sche.sceneMode;
    let sceneValue = sche.sceneValue;
    let groupIDs = sche.groupIDs;
    let repeatMode = sche.repeatMode; //星期 (高字节：日程0-循环 1-执行一次； 应急电源0)
    let repeatWeek = sche.repeatWeek; //0-日程 1～4应急电源（profile存1～4， 指令执行0～3）

    //应急电源week处理
    repeatWeek = repeatWeek - 1;
    if (repeatWeek < 0) repeatWeek = 0;
    //日程高字节为1 特殊处理
    if (repeatMode > 127) repeatMode = 255;

    let length = 28;
    if (sceneMode == parseInt('1021', 16) || sceneMode == parseInt('1061', 16) || sceneMode == parseInt('1081', 16) || sceneMode == parseInt('1091', 16)) {
        sceneValue = transIntToHex4Str(sceneValue);
        length = 29;
    } else {
        sceneValue = transIntToHex2Str(sceneValue);
    }

    //第一条指令
    let data1 = transIntToHex2Str(sceneID) + transIntToHex2Str(repeatMode) + transIntToHex4Str(repeatWeek * 4096 + time) + getOctets2Msg(sceneMode) + sceneValue;
    data1 = '00610000000000000F' + 'FFFFFFFFFFFF' + '00640000' + '0120' + data1;
    data1 = '0,' + '2525' + transIntToHex2Str(length) + '00' + data1 + sumHexBytes(data1) + '5252' + ',';
    PubSub.publish('showUpdate', data1)//控制mqtt发信息0210

    //第二条指令
    let data2 = '';
    if (groupIDs.length == 0 || opcode_type == Opcode_delete) {
        data2 = transIntToHex2Str(sceneID) + '000000' + '000000'; //6个字节0 （删除特殊对应）
        data2 = '00610000000000000F' + 'FFFFFFFFFFFF' + '00640000' + '0220' + data2;
        data2 = '0,' + '25251C00' + data2 + sumHexBytes(data2) + '5252' + ',';
    } else if (groupIDs.length <= 5) {
        let msg = '';
        for (let i = 0; i < groupIDs.length; i++) {
            msg = msg + transIntToHex2Str(groupIDs[i]);
        }
        meshLog('msg', msg);
        data2 = transIntToHex2Str(sceneID) + transIntToHex2Str(groupIDs.length) + transIntToHex2Str(groupIDs.length) + msg;
        data2 = '00610000000000000F' + 'FFFFFFFFFFFF' + '00640000' + '0220' + data2;
        data2 = '0,' + '2525' + transIntToHex2Str(24 + groupIDs.length) + '00' + data2 + sumHexBytes(data2) + '5252' + ',';
    } else {
        //超过5个组
        let msg = '';
        for (let i = 0; i < 5; i++) {
            msg = msg + transIntToHex2Str(groupIDs[i]);
        }
        data2 = transIntToHex2Str(sceneID) + transIntToHex2Str(5) + transIntToHex2Str(5) + msg;
        data2 = '00610000000000000F' + 'FFFFFFFFFFFF' + '00640000' + '0220' + data2;
        data2 = '0,' + '2525' + transIntToHex2Str(24 + 5) + '00' + data2 + sumHexBytes(data2) + '5252' + ',';
    }

    setTimeout(() => {
        PubSub.publish('showUpdate', data2)//控制mqtt发信息0220
    }, 300)



    meshLog('wjk 日程相关1', data1);
    meshLog('wjk 日程相关2', data2);
}
